import {LinkType} from 'shared/types';
import {getMedia} from 'shared/utils';

import {
  SpotifyAlbumLink,
  SpotifyPlaylistLink,
  SpotifySongLink,
  SpotifyPodcastLink,
  SpotifyArtistLink,
  SpotifyShowLink,
} from '../Spotify';
import {YouTubePlaylistLink, YouTubeVideoLink} from '../YouTube';
import {CardStyle, getRichLinkCardStyle} from 'shared/utils/CardStyleUtil';
import classNames from 'classnames';

const supportedMediaLinks = [
  LinkType.SpotifyAlbumLink,
  LinkType.SpotifyArtistLink,
  LinkType.SpotifyPlaylistLink,
  LinkType.SpotifySongLink,
  LinkType.SpotifyPodcastLink,
  LinkType.SpotifyShowLink,
  LinkType.YouTubePlaylistLink,
  LinkType.YouTubeVideoLink,
] as const;

const embedComponents = {
  SpotifyAlbumLink,
  SpotifyArtistLink,
  SpotifyPlaylistLink,
  SpotifySongLink,
  SpotifyPodcastLink,
  SpotifyShowLink,
  YouTubePlaylistLink,
  YouTubeVideoLink,
} as const;

export interface MediaLink {
  title: string;
  url: string;
  id: string;
  __typename: typeof supportedMediaLinks[number];
}

export const isSupportedMediaLink = (link: {
  __typename: string;
}): link is MediaLink =>
  'url' in link &&
  (link.__typename === LinkType.SpotifyAlbumLink ||
    link.__typename === LinkType.SpotifyArtistLink ||
    link.__typename === LinkType.SpotifyPlaylistLink ||
    link.__typename === LinkType.SpotifySongLink ||
    link.__typename === LinkType.SpotifyPodcastLink ||
    link.__typename === LinkType.SpotifyShowLink ||
    link.__typename === LinkType.YouTubePlaylistLink ||
    link.__typename === LinkType.YouTubeVideoLink);

export const MediaLinkCard = ({
  link,
  style,
}: {
  link: MediaLink;
  style: CardStyle;
}) => {
  const parsedMedia = getMedia(link.url);
  if (!parsedMedia?.mediaId || parsedMedia.type !== link.__typename) {
    return null;
  }

  const EmbedComponent = embedComponents[link.__typename];
  return (
    <article
      data-testid="link-card-container"
      className={classNames(
        'bg-white',
        'rounded',
        'shadow',
        'p-2',
        'w-full',
        'text-black',
      )}
      style={getRichLinkCardStyle(style)}
    >
      <h2 className={classNames('text-left', 'mb-2')}>{link.title}</h2>
      <EmbedComponent mediaId={parsedMedia?.mediaId} title={link.title} />
    </article>
  );
};
